<template>
  <div
    id="page"
    class="flex min-h-full flex-col md:flex-row md:pl-16">
    <TheSidebar />

    <main
      id="content"
      :class="['flex grow flex-col justify-between', classMain]">
      <div :class="['flex grow flex-col', classContent]">
        <slot />
      </div>

      <footer class="mt-8 flex flex-col gap-y-0.5 gap-x-2 py-4 pl-4 pr-16 text-xs md:flex-row">
        <p class="mb-2">Current time: {{ getDate() }}.</p>
        <p id="fn-patent">
          Traxo products are protected by&nbsp;<LinkNormal
            as="a"
            href="https://www.traxo.com/patents"
            inline
            >patents.</LinkNormal
          >
        </p>
        <p>
          Use of Traxo is bound by our
          <LinkNormal
            as="a"
            href="https://www.traxo.com/agreement">
            User Agreement.
          </LinkNormal>
        </p>
      </footer>
    </main>
  </div>
</template>

<script setup>
import TheSidebar from '@/components/the-sidebar.vue';
import LinkNormal from '@/components/links/LinkNormal.vue';

defineProps({
  classMain: {
    type: String,
    default: 'bg-white',
  },
  classContent: {
    type: String,
    default: '',
  },
});

function getDate() {
  const now = new Date();
  const dateOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  };
  const timeOptions = {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'UTC',
    timeZoneName: 'short',
  };

  return `
        ${now.toLocaleDateString('en-US', dateOptions)}
        ${now.toLocaleTimeString('en-US', timeOptions)}
      `;
}
</script>
